import * as React from 'react'
import RowItem from './row_item'
import { ItemBoxType } from './item_types'

const { I18n } = window as any

type TargetBoxProps = {
  items: ItemBoxType[]
  removeItem: (item: any) => void
  removeAll: () => void
  approvedLocationIDs: any
  campaignLocationsNeedApproval: boolean
}

export default function TargetBox(props: TargetBoxProps) {
  const { items, removeItem, removeAll, approvedLocationIDs, campaignLocationsNeedApproval } = props
  return (
    <table className="table table-bordered table-hover table-striped table-sm">
      <thead className="">
        <tr>
          <th className="w-20">
            <a onClick={removeAll} className="action-control">
              <i className="fa fa-angle-double-left" />
              &nbsp;
              {I18n.t('application.actions.remove_all')}
            </a>
          </th>
          <th>{I18n.t('activerecord.attributes.elements/base_element.location_number')}</th>
          <th className="w-30">
            {I18n.t('activerecord.models.location.other')} ({items.length})
          </th>
          {campaignLocationsNeedApproval && (
            <th>{I18n.t('activerecord.attributes.elements/base_element.approved.approved')}</th>
          )}
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <RowItem
            item={item}
            direction="reverse"
            key={`item-key-${item.id}`}
            action={removeItem}
            approvedLocationIDs={approvedLocationIDs}
            campaignLocationsNeedApproval={campaignLocationsNeedApproval}
          />
        ))}
      </tbody>
    </table>
  )
}
